import { render, staticRenderFns } from "./TeacherBirthday.vue?vue&type=template&id=788cbe6a&scoped=true"
import script from "./TeacherBirthday.vue?vue&type=script&lang=js"
export * from "./TeacherBirthday.vue?vue&type=script&lang=js"
import style0 from "./TeacherBirthday.vue?vue&type=style&index=0&id=788cbe6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788cbe6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('788cbe6a')) {
      api.createRecord('788cbe6a', component.options)
    } else {
      api.reload('788cbe6a', component.options)
    }
    module.hot.accept("./TeacherBirthday.vue?vue&type=template&id=788cbe6a&scoped=true", function () {
      api.rerender('788cbe6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/birthdaymanagement/TeacherBirthday.vue"
export default component.exports